import { Carousel, Container, Col, Row } from "react-bootstrap";
import { useState } from "react";
import "./imagesliderComponent.css";
import "../general.css";

export const ImageSlider = ({ language }) => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Container className="container-page" id="slider">
      <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
        <div id="carousel">
          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            className="carousel"
            data-aos="fade-up"
            data-aos-delay="50"
            data-aos-duration="500"
            data-aos-mirror="false"
            data-aos-once="true"
          >
            {slideData.map((info, i) => {
              return (
                <Carousel.Item key={i}>
                  <img
                    className="d-block w-100 carousel-pic"
                    alt={info.id}
                    id={info.id}
                  />
                  {info.caption && (
                    <Carousel.Caption>
                      <div className="caption-info-box">
                        <h3>
                          {language === "fin" && <div>{info.title.fin}</div>}
                          {language === "eng" && <div>{info.title.eng}</div>}
                          {language === "swe" && <div>{info.title.swe}</div>}
                        </h3>
                        <Row>
                          <Col className="slide-description">
                            {language === "fin" && info.description.fin}
                            {language === "eng" && info.description.eng}
                            {language === "swe" && info.description.swe}
                          </Col>
                        </Row>
                      </div>
                    </Carousel.Caption>
                  )}
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
      </div>
    </Container>
  );
};

const slideData = [
	{
	id: "k18_slide",
	caption: true,
	title: {
		fin: "Meiltä löytyy nyt kaikki K18 hiushoidot",
		eng: "We now offer the full range of K18 hair treatments",
		swe: "Vi har nu alla K18 hårbehandlingar",
    },
    description: {
		fin: <div>"Palauta hiustesi vahvuus ja elinvoima! Meiltä löytyy nyt kaikki K18 hiushoidot. Hiushoidot hiustenvärjäyksen tai -leikkauksen yhteydessä alk.30€"</div>,
		eng: <div>"Restore the strength and vitality of your hair! We now offer the full range of K18 hair treatments. Hair treatments with coloring or cutting starting from €30"</div>,
		swe: <div>"Återställ styrkan och livskraften i ditt hår! Vi har nu alla K18 hårbehandlingar. Hårbehandlingar i samband med färgning eller klippning från 30 €"</div>
    },
  },
  {
    id: "eleven_slide",
    caption: true,
    title: {
      fin: "Myynnissä meillä löytyy Eleven Australia hiustuotteita",
      eng: "We sell Eleven Australia hairproducts",
      swe: "Vi säljer Eleven Australia hårvårdsprodukter",
    },
    description: {
      fin: (
        <div></div>
      ),
      eng: (
        <div></div>
      ),
      swe: (
        <div></div>
      ),
    },
  },
  {
    id: "rekry",
    caption: false,
    title: {
      fin: "",
      eng: "",
      swe: "",
    },
    description: {
      fin: <div></div>,
      eng: <div></div>,
      swe: <div></div>,
    },
  },
  {
    id: "davines-products",
    caption: true,
    title: {
      fin: "Myynnissä meiltä löytyy Davines hiustuotteita",
      eng: "We sell Davines hairproducts",
      swe: "Vi säljer Davines hårvårdsprodukter",
    },
    description: {
      fin: (
        <div>Kestävästi kehitetty hiushoitosarja joka tuotetaan Italiassa.</div>
      ),
      eng: <div> Sustainable haircare brand made in Italy.</div>,
      swe: (
        <div>Hållbart utvecklad hårvårdsserie som tillverkas i Italien.</div>
      ),
    },
  },
  {
    id: "bjork-products",
    caption: true,
    title: {
      fin: "Myynnissä meillä löytyy Björk hiustuotteita",
      eng: "We sell Björk hairproducts",
      swe: "Vi säljer Björk hårvårdsprodukter",
    },
    description: {
      fin: (
        <div>
          Björk on vegaaninen, kestävästi kehitetty hiushoitosarja joka
          tuotetaan Ruotsissa.
        </div>
      ),
      eng: (
        <div>Björk is a sustainable, vegan haircare brand made in Sweden.</div>
      ),
      swe: (
        <div>
          Björk är en vegansk och hållbart utvecklad hårvårdsserie som
          tillverkas i Sverige.
        </div>
      ),
    },
  },
  {
    id: "partnership",
    caption: true,
    title: {
      fin: "",
      eng: "",
      swe: "",
    },
    description: {
      fin: (
        <div>
          Ilmainen hiuspalvelu videosisältöä vastaan!\nTee meille upea video sinulle toteutetusta hiuspalvelusta, ja saat palvelun itsellesi veloituksetta!\nEtsimme UGC-sisällöntuottajia ja vaikuttajayhteistöitä!\nIlmoita kiinnostuksestasi sähköpostitse tai instagramin kautta jossa kerrot hieman itsestäsi ja olemme sinuun yhteydessä, mikäli voisimme olla hyvä match.
        </div>
      ),
      eng: (
        <div>Free hair service in exchange for video content!\nCreate a stunning video about the hair service you receive from us, and you’ll get the treatment completely free of charge!\nWe’re looking for UGC creators and influencer collaborations!\nLet us know your interest by email or via Instagram — tell us a bit about yourself, and we’ll get in touch if we think we could be a good match.</div>
      ),
      swe: (
        <div>
          Gratis hårservice i utbyte mot videoinnehåll!\nGör en fantastisk video om den hårservice du får hos oss, så får du behandlingen helt kostnadsfritt\nVi söker UGC-innehållsskapare och samarbeten med influencers!\nAnmäl ditt intresse via e-post eller Instagram, berätta lite om dig själv, så kontaktar vi dig om vi tror att vi kan vara en bra match.
        </div>
      ),
    },
  },
  {
    id: "miracle-boost-slider",
    caption: true,
    title: {
      fin: "",
      eng: "",
      swe: "",
    },
    description: {
      fin: (
        <div>
          Meiltä löytyy myös Miracle Booster Tehohoito.
        </div>
      ),
      eng: (
        <div>We also have the Miracle Booster Treatment.</div>
      ),
      swe: (
        <div>
          Vi har även en Miracle Booster inpackning.
        </div>
      ),
    },
  }
];
